import CRUDService from './CRUDService';
import {CollegeMajor} from 'src/types/college';

export default new CRUDService<CollegeMajor>('/v1/lists/college-majors');
